// extracted by mini-css-extract-plugin
export default {"decorator":"_1W0gB0UR_Ag3_lKXg7Q9-S","icon":"KDnTYZvawNRK5ANhCmNWs"};